<template>
  <form @submit.prevent="processForm" ref="form" >
    <slot></slot>
  </form>
</template>

<script>
import jwtInterceptor from '@/shared/jwtInterceptor';
import {showSystemNoti} from "@/shared/helper";

export default {
  name: "AjaxForm",
  data:function (){
    return {
    }
  },
  methods: {
    reset()
    {
      this.$refs['form'].reset()
    },
    async processForm()
    {
      let currentBtnText = '';
      const submitBtn = this.$refs['form'].querySelector('button[type="submit"]');
      if (submitBtn)
      {
        currentBtnText = submitBtn.innerHTML;
        submitBtn.innerHTML = '<i class="fa fa-spin fa-spinner-third fa-fast-anime"></i>';
        submitBtn.disabled = true;
      }
      const formData = new FormData(this.$refs['form']);
      // const data = {};
      // for (let [key, val] of formData.entries()) {
      //   Object.assign(data, { [key]: val })
      // }
      const config = {};
      config.headers = {
        'Content-Type': 'multipart/form-data'
      }

      if (this.route)
      {
        const url = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH + this.route;
        try
        {
          const response = await jwtInterceptor.post(url,formData,config);
          if (response && response.data)
          {
            const result = response.data;
            if (this.callback && typeof this.callback==="function")
            {
              this.callback(result);
            }
            else if (result.error)
            {
              if (!this.silent)
                showSystemNoti('danger',result.error)
            }
            else if (result.ok && result.message)
            {
              if (!this.silent)
                showSystemNoti('success',result.message)
            }
          }
          if (submitBtn)
          {
            submitBtn.innerHTML = currentBtnText;
            submitBtn.disabled = false;
          }
        }
        catch (e)
        {
          if (e.response && e.response.data)
          {
            const result = e.response.data;
            if (this.callback && typeof this.callback==="function")
            {
              this.callback(result);
            }
            else if (result.error)
            {
              if (!this.silent)
                showSystemNoti('danger',result.error)
            }
            else if (result.ok && result.message)
            {
              if (!this.silent)
                showSystemNoti('success',result.message)
            }
          }
          else
          {
            if (!this.silent)
            {
              showSystemNoti('danger', 'خطا در برقراری ارتباط با سرور')
            }
            if (submitBtn)
            {
              submitBtn.innerHTML = currentBtnText;
              submitBtn.disabled = false;
            }
          }
          if (submitBtn)
          {
            submitBtn.innerHTML = currentBtnText;
            submitBtn.disabled = false;
          }
        }
      }
    },
  },
  props: ['route','silent','callback','files']
}
</script>

<style scoped>

</style>